import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { nanoid } from 'nanoid';
import type { CollectionsSelectorConfig, ViewSectionConfiguration } from '@ilteducation/content-views-types';
import type { MemberRole } from '@ilteducation/content-collections-types';
import CollectionsById from '@/components/view/CollectionsById.vue';
import CollectionsPreview from '@/components/view/CollectionsPreview.vue';
import CollectionByMembership from '@/components/view/CollectionByMembership.vue';
import MovableItem from '@/components/base/MovableItem.vue';
type Props = {
  section: ViewSectionConfiguration;
  realm: string;
  subscription: string;
};

// TODO change to import. This is hack, because get error when try to import MemberRole as just a variable
// eslint-disable-next-line
// @ts-ignore
type IdSelector = {
  id: string;
  selector: CollectionsSelectorConfig;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionConfigurator',
  props: {
    section: null,
    realm: null,
    subscription: null
  },
  emits: ["remove-section", "update-section", "add-selector"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'remove-section', id: string): void;
  (e: 'update-section', section: ViewSectionConfiguration): void;
  (e: 'add-selector', id: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  section: ViewSectionConfiguration;
  realm: string;
  subscription: string;
}

const memberRole: MemberRole = 'owner';


const selectors = ref<IdSelector[]>(
  props.section.selectors.map((sel: CollectionsSelectorConfig) => ({ id: nanoid(5), selector: sel })),
);
const dragging = ref(false);
const dialog = ref(false);
const availableSelectors = ref([
  {
    type: 'ContentSharedCollectionSelector',
    title: 'Shared Content Collection',
    text: 'Here will be displayed content shared with user',
    component: CollectionsPreview,
  },
  {
    type: 'ContentSharedByMeCollectionSelector',
    title: 'Shared By Me Collection',
    text: 'Here will be displayed content the user has shared with others',
    component: CollectionsPreview,
  },
  {
    type: 'FavouritesCollectionSelector',
    title: 'Favourites Collection',
    text: 'Here will be displayed user favourites',
    component: CollectionsPreview,
  },
  {
    type: 'HistoryCollectionSelector',
    title: 'History Collection',
    text: 'Here will be displayed user history',
    component: CollectionsPreview,
  },
  {
    type: 'CollectionsByIds',
    title: 'Collections by Ids',
    text: 'Here will be displayed collections by ids',
    component: CollectionsById,
  },
  {
    type: 'CollectionsByMembershipSelector',
    title: 'Collections by Membership',
    text: 'Here will be displayed collections by user membership',
    component: CollectionByMembership,
  },
]);
const selectedCollType = ref<string>(availableSelectors.value[0].type);
const componentData = ref({
  props: {
    type: 'transition',
    name: 'flip-list',
  },
});



const removeSection = () => {
  emits('remove-section', props.section.id);
};
const addSelector = () => {
  const id = nanoid(5);
  switch (selectedCollType.value) {
    case 'CollectionsByIds':
      selectors.value.unshift({
        id,
        selector: {
          type: 'CollectionsByIds',
          ids: [],
        },
      });
      break;
    case 'FavouritesCollectionSelector':
      selectors.value.unshift({
        id,
        selector: {
          type: 'FavouritesCollectionSelector',
          context: props.subscription,
        },
      });
      break;
    case 'ContentSharedCollectionSelector':
      selectors.value.unshift({
        id,
        selector: {
          type: 'ContentSharedCollectionSelector',
          context: props.subscription,
        },
      });
      break;
    case 'ContentSharedByMeCollectionSelector':
      selectors.value.unshift({
        id,
        selector: {
          type: 'ContentSharedByMeCollectionSelector',
          context: props.subscription,
        },
      });
      break;
    case 'HistoryCollectionSelector':
      selectors.value.unshift({
        id,
        selector: {
          type: 'HistoryCollectionSelector',
        },
      });
      break;
    case 'CollectionsByMembershipSelector':
      selectors.value.unshift({
        id,
        selector: {
          type: 'CollectionsByMembershipSelector',
          role: memberRole,
          context: props.subscription,
        },
      });
      break;
    default:
      console.log(`Unknowns collection type: ${selectedCollType.value}`);
  }
  emits('update-section', {
    id: props.section.id,
    selectors: selectors.value.map((selAndId) => selAndId.selector),
  });
};
const change = () => {
  emits('update-section', {
    id: props.section.id,
    selectors: selectors.value.map((idAndSel) => idAndSel.selector),
  });
};

const updateSelectors = (newSelectors: IdSelector[]) => {
  selectors.value = newSelectors;
  change();
};

const getSelectorPreview = (collectionSelector: CollectionsSelectorConfig) => {
  const selector = availableSelectors.value.find((sel) => sel.type === collectionSelector.type);
  if (selector) {
    return selector;
  }
  throw Error(`Unknown type ${collectionSelector.type}`);
};

const updateSelector = (id: string, collectionSelector: CollectionsSelectorConfig) => {
  selectors.value.find((sel) => sel.id === id).selector = collectionSelector;
  change();
};

return { __sfc: true,memberRole, props, selectors, dragging, dialog, availableSelectors, selectedCollType, componentData, emits, removeSection, addSelector, change, updateSelectors, getSelectorPreview, updateSelector, MovableItem }
}

})